export const mapStatusToStatusStyle = status => {
  switch (status) {
    case 'Active':
      return { backgroundColor: '#104b00', color: '#fff' };
    case 'Binder Received':
      return { backgroundColor: '#2f9f11' };
    case 'BOR Confirmed':
    case 'Request Issued':
      return { backgroundColor: '#6f9b13' };
    case 'BOR Transfer':
      return { backgroundColor: '#8b9f60', color: '#000' };
    case 'Issued':
      return { backgroundColor: '#197600' };
    case 'RI Manual':
      return { backgroundColor: '#c6d62a', color: '#000' };
    case 'Cancel/NR':
    case 'Cancel':
    case 'Cancelled':
      return { backgroundColor: '#b0aeca' };
    case 'Bind Declined':
    case 'Carrier Declined':
    case 'Internal Declined':
      return { backgroundColor: '#b22222' };
    case 'Bound':
      return { backgroundColor: '#9ed62a', color: '#000' };
    case 'Selected':
      return { backgroundColor: '#b3e833', color: '#000' };
    case 'Add. Info-Client':
    case 'Additional Info':
      return { backgroundColor: '#d4d4d4', color: '#000' };
    case 'Carrier Quoting':
      return { backgroundColor: '#d2b48c', color: '#000' };
    case 'Proposed':
      return { backgroundColor: '#ffa500', color: '#000' };
    default:
      return { backgroundColor: '#d4d4d4', color: '#000' };
  }
};

export const mapStatusToCardStyle = status => {
  return status === 'Cancelled' || status === 'Expired' || status === 'Declined'
    ? {
        backgroundColor: '#f0f2f5',
        border: '1px solid #d9d8ea',
      }
    : {};
};

export const showViewDetails = data => {
  return data.IsViewDetailsButtonVisible;
};
